import NotImplementedError from './not-implemented'

export default class Storage {
    /**
     * @abstract
     * @param {string} name - The name of the file in storage
     * @param {string} data - The data to place into the storage container
     * @returns {Promise} The result of the asynchronous upload operation
     */
    upload(name, data) { throw new NotImplementedError('Storage.upload must be implemented by a subclass') }
}
